import { Component, Input } from '@angular/core';
import { TwoWayBoundComponent } from '@app/shared/components/base/two-way-bound.component';
import { DisplayName } from '@app/shared/components/select/base-select-with-id.component';
import { CdkDragDrop,  moveItemInArray } from '@angular/cdk/drag-drop';

export interface Chipable extends DisplayName {
    notRemovable?: boolean;
    notSelectable?: boolean;
}

export interface DragNDropChipable extends Chipable {
    sort_order: number;
}

@Component({
    selector: 'drag-n-drop-chips',
    templateUrl: './drag-n-drop-chips.component.html',
    styleUrls: ['./drag-n-drop-chips.component.scss']
})
export class DragNDropChipsComponent extends TwoWayBoundComponent<DragNDropChipable[]> {

    @Input()
    public selectionList?: DragNDropChipable[];

    @Input()
    public selectionListLabel?: string;

    public selectSelection: DragNDropChipable;

    get chipsElements(): DragNDropChipable[] {
        return this.bananaBox;
    }

    set chipsElements(updatedElements: DragNDropChipable[]) {
        this.bananaBox = updatedElements;
    }

    constructor() {
        super();
        this._idPrefix = 'drag-n-drop-chips.';
    }

    public addElement(): void {
        const chip = this.selectSelection;
        chip.sort_order = this.chipsElements.length;
        this.chipsElements.push(chip);
        this.onChange();
        this.selectSelection = null;
    }

    public removeElement(chipToRemove: DragNDropChipable): void {
        this.chipsElements = this.chipsElements.filter(chip => chip.sort_order !== chipToRemove.sort_order);
        this.chipsElements.forEach(chip => {
            if (chip.sort_order > chipToRemove.sort_order) {
                chip.sort_order--;
            }
        });

        this.onChange();
    }

    public setNewChipOrder(dragDrop: CdkDragDrop<any>): void {
        moveItemInArray(this.bananaBox, dragDrop.previousIndex, dragDrop.currentIndex);

        for (let i = 0; i < this.bananaBox.length; i++) {
            this.bananaBox[i].sort_order = i;
        }
    }

}
